import React, { useEffect } from 'react';
import { Input, Spinner } from "reactstrap";
import useApi from "../../hooks/useApi";

function ProjectTypeSelect({ onError, onProjectTypeChange }) {
    const projectTypeApi = useApi('projecttype');

    useEffect(() => {
        if (!projectTypeApi.loading) {
            if (!projectTypeApi.error) {
                projectTypeApi.get();
            } else {
                handleError(projectTypeApi.error.detail);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectTypeApi.error]);

    const handleError = (message) => {
        if (typeof onError === 'function') {
            onError(message);
        }
    }

    const handleProjectTypeChange = (e) => {
        let selectedOption = e.target.options[e.target.selectedIndex];
        let selectedProjectId = parseInt(selectedOption.value);

        onProjectTypeChange(projectTypeApi.data?.find(projectType => projectType.id === selectedProjectId));
    }

    var projectTypeOptions = projectTypeApi.data
        ? projectTypeApi.data.map(
            (projectType) => <option key={projectType.id} value={projectType.id}>{projectType.description}</option>
            )
        : [];

    return (
        <div className="form-group">
            <div className="input-group">
                <Input type="select" defaultValue="" onChange={handleProjectTypeChange}>
                    <option value="" disabled hidden>Choose an option...</option>
                    {projectTypeOptions}
                </Input>
                <div className={!projectTypeApi.loading ? "visually-hidden" : "mt-2"}>
                    <Spinner size="sm">
                    </Spinner>
                </div>
            </div>
        </div>
    );
}

export default ProjectTypeSelect;